import { useField } from 'remix-validated-form'
import ReCAPTCHA from 'react-google-recaptcha'
import { useState } from 'react'

interface RecaptchaProps {
  name: string
  siteKey?: string
}

export default function Recaptcha(props: RecaptchaProps) {
  const { error } = useField(props.name)
  const [result, setResult] = useState('')

  return (
    <>
      <input type="hidden" name={props.name} value={result} />

      <ReCAPTCHA
        sitekey={props.siteKey ?? ''}
        onChange={(value: string | null) => setResult(value ?? '')}
        onExpired={() => setResult('')}
      />

      {error && <span className="text-sm text-danger-500">{error}</span>}
    </>
  )
}
